class Facts {

    constructor() {
        this.root = $('.js-facts-slider');
        if (!this.root.length) return;
        this.slides = $('.js-facts-slider-item', this.root);
        this.slidesBg = $('.js-facts-slider-bg', this.root);
        this.bullets = $('.js-facts-slider-bullets', this.root);
        this.next = $('.js-facts-slider-next', this.root);
        this.prev = $('.js-facts-slider-prev', this.root);
        this.promoButton = $('.js-promo-next', this.root);
        this.mapLinks = $('.js-facts-promo-person', this.root);
        this.currentSlide = this.slides.filter('._active').length ? this.slides.filter('._active') : this.slides.eq(0);
        this.animating = false;
        this.duration = 800;

        this.init();
    }

    init() {
        this.root.addClass('_dir-prev');
        this.currentSlide.next().addClass('_prev');

        this.slides.each((i,el) => {
            this.bullets.append('<i' + (i == this.currentSlide.index() ? ' class="_active"' : '') + '>');
            $(el).find('.js-facts-slider-number').text($(el).index() > 9 ? $(el).index() : '0' + $(el).index());
            $(el).find('.js-facts-slider-total').text(this.slides.length > 9 ? this.slides.length - 1 : '0' + (this.slides.length - 1));
        });

        if (this.root.data('preRender')) {
            this.root.on('preRenderEnd', () => {
                this.currentSlide.addClass('_active');
                this.initFirstSlide();
                this.bind();
            });
        } else {
            this.currentSlide.addClass('_active');
            this.initFirstSlide();
            this.bind();
        }
    }

    bind() {
        if (device.mobile() || device.tablet()) {
            this.root.hammer().on('swipeleft', (ev) => {
                this.next.click();
            });

            this.root.hammer().on('swiperight', (ev) => {
                this.prev.click();
            });
        }

        this.mapLinks.on('click', (e) => {
            e.preventDefault();
            if (this.animating) return;
            $(e.currentTarget).parent().addClass('__clicked');
            setTimeout(() => {
                $(e.currentTarget).parent().removeClass('__clicked');
                this.slideTo(this.slides.eq($(e.currentTarget).data('person')));
                $(document).trigger('counters:main_advantages_block_click');
            }, (device.mobile() || device.tablet()) ? this.duration : 0);
        });

        this.promoButton.on('click', ()=> {
            this.slideTo(this.slides.eq(1));
            $(document).trigger('counters:main_advantages_block_click');
        });

        this.next.on('click', (e) => {
            this.slideTo(this.currentSlide.next().length ? this.currentSlide.next() : this.slides.eq(0));
        });

        this.prev.on('click', (e) => {
            this.slideTo(this.currentSlide.prev().length ? this.currentSlide.prev() : this.slides.eq(this.slides.length - 1));
        });

        this.bullets.find('i').on('click', (e) => {
            this.slideTo(this.slides.eq($(e.currentTarget).index()));
        });

        $(window).on('scroll', $.proxy(this.inViewport, this));
    }

    slideTo(slide) {
        if (this.animating || this.currentSlide[0] == slide[0]) return;
        this.animating = true;
        this.root.removeClass('_dir-prev _dir-next');
        this.slides.removeClass('_prev');
        if(this.currentSlide.index() - slide.index() == (this.slides.length - 1) || (this.currentSlide.index() - slide.index() != -(this.slides.length - 1) && this.currentSlide.index() < slide.index())) {
            this.root.addClass('_dir-next');
        } else {
            this.root.addClass('_dir-prev');
        }
        this.currentSlide.addClass('_leaving');
        this.bullets.find('i').removeClass('_active').eq(slide.index()).addClass('_active');
        this.root[0].offsetHeight; // задержка
        this.root.addClass('_animating');

        setTimeout(() => {
            //this.animating = false;

            this.currentSlide.removeClass('_active').addClass('_prev');
            this.currentSlide = slide.addClass('_active');
            this.root.attr('data-active', this.currentSlide.index());
            // this.slidesBg.css({
            //     color: this.currentSlide.data('colors').split(',')[0],
            //     fill: this.currentSlide.data('colors').split(',')[1]
            // });
            // this.currentSlide.css({
            //     fill: this.currentSlide.data('colors').split(',')[0]
            // });
            if (this.currentSlide.index() === 0) {
                this.currentSlide.find('._hover-map').removeClass('_hover-map');
                this.currentSlide.find('.facts-promo__content-item').eq(0).addClass('_hover-map');
            }
            this.root[0].offsetHeight; // задержка
            this.slides.removeClass('_leaving');

            setTimeout(() => {
                this.animating = false;
                this.root.removeClass('_animating');
            }, this.duration);
        }, this.duration / 2);
    }

    initFirstSlide() {
        //let teamPromo = $('.js-facts-promo');
        let creative = $('.js-facts-promo-creative');
        let persons = $('.js-facts-promo-person');
        let content = $('.js-facts-promo-content').children();

        if (device.desktop()) {
            $('.js-facts-promo-map area').hover(function () {
                if ($(this).closest('.js-facts-slider').hasClass('_animating')) return;
                content.eq(0).removeClass('_hover-map');
                persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).addClass('_hover-map');
            }, function () {
                if ($(this).closest('.js-facts-slider').hasClass('_animating')) return;
                content.eq(0).addClass('_hover-map');
                persons.eq($(this).index()).add(creative).add(content.eq($(this).index() + 1)).removeClass('_hover-map');
            });
            $('.js-facts-promo-map').imageMapResize();
        }
    }

    inViewport () {
        if (this.root.is(':in-viewport')) {
            var props = this.root[0].getBoundingClientRect();

            if (props.top < screen.availHeight / 2 && props.bottom > screen.availHeight / 2) {
                $(document).trigger('counters:main_advantages_block_show');
                $(window).off('scroll', $.proxy(this.inViewport, this));
            }
        }
    }
}

let facts = new Facts();

export default facts;


// WEBPACK FOOTER //
// ./_src/js/facts.js